import React from 'react'
import styled from "styled-components"

const TopContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 1rem;
`
const LogoContainer = styled.div`
    /* display: flex; */
    width: 10rem;
    height: 10rem;
    /* justify-content: center; */
`

const LogoImg = styled.img`
    object-fit: cover;
    width: 100%;
    height: 100%;
`

export default function Logo() {
  return (
    <TopContainer>
        <LogoContainer>
            <LogoImg src='/assets/logo/logo.png' alt='Sondos'/>
        </LogoContainer>
    </TopContainer>
  )
}
